export function withCurrentSearchParams(path: string): string {
  return withCurrentSearchParamsExcept(path, []);
}

export function withCurrentSearchParamsExcept(path: string, exclude: readonly string[]): string {
  if (typeof window === 'undefined') return path;

  const url = new URL(path, window.location.origin);
  const currentSearch = window.location.search;
  if (!currentSearch) return `${url.pathname}${url.search}${url.hash}`;

  const currentParams = new URLSearchParams(currentSearch);
  const excluded = new Set(exclude);

  for (const [key, value] of currentParams) {
    if (excluded.has(key)) continue;
    url.searchParams.set(key, value);
  }

  return `${url.pathname}${url.search}${url.hash}`;
}
